import { Box, Card, CardBody, CardHeader, Heading, Text } from "grommet";
import { useNavigate } from "react-router-dom";
import colors from "../colors";

const ProfileCard = ({
  teamMember,
  pictureType = "profile",
  pictureOnly = false,
}) => {
  const navigate = useNavigate();
  return (
    <Card
      background={{ color: colors.light, opacity: "50%" }}
      round="0px"
      elevation="large"
      key={teamMember.key}
      onClick={pictureOnly ? false : () => {
        navigate("/team/" + teamMember.key.current);
      }}
    >
      {!pictureOnly && (
        <CardHeader
          pad="small"
          direction="column"
          align="center"
          gap={"none"}
          height={"xsmall"}
          justify="start"
        >
          <Heading level={3} margin="none">
            {teamMember.title}
          </Heading>
          <Text size="small">
            <i>{teamMember.credentials}</i>
          </Text>
        </CardHeader>
      )}
      <CardBody pad="medium">
        <Box
          height="medium"
          width="medium"
          round="small"
          background={{
            image:
              "url(" +
              (pictureType === "office"
                ? teamMember.officePictureUrl
                : teamMember.profilePictureUrl) +
              ")",
            position: "center",
          }}
          alignSelf="center"
        ></Box>
      </CardBody>
    </Card>
  );
};

export default ProfileCard;
